export class Company {
    public name: string = "";
    public telephone: string = "";
    public address: string = "";
    public postal_code: string = "";
    public city: string = "";
    public email: string = "";
}